import React, { forwardRef, useState } from 'react';
import { Input, type InputProps, type InputRef } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './authForm.module.scss';

/**
 * Pole hasła z prawdziwym przyciskiem „Pokaż hasło” (antd `Input.Password` ma ikonę bez fokusu
 * z klawiatury). Etykieta stała, stan niesie `aria-pressed`. Props przekazuje `Form.Item`.
 */
const PasswordInput = forwardRef<InputRef, Omit<InputProps, 'type' | 'suffix'>>((props, ref) => {
  const { t } = useTranslation('auth');
  const [visible, setVisible] = useState(false);

  return (
    <Input
      {...props}
      ref={ref}
      type={visible ? 'text' : 'password'}
      suffix={
        <button
          type="button"
          className={styles.reveal}
          aria-label={t('auth:screens.field.showPassword')}
          aria-pressed={visible}
          disabled={props.disabled}
          onClick={() => setVisible((value) => !value)}
        >
          {visible ? <EyeInvisibleOutlined aria-hidden /> : <EyeOutlined aria-hidden />}
        </button>
      }
    />
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
